import React, { useState } from "react";
import { withRouter } from 'react-router-dom';
import { Redirect, useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from "@material-ui/core/styles";

import logo from "../img/logoNoText.png";
import Copyright from "../components/Login/Copyright";

import {
    AppBar,
    CssBaseline,
    Drawer,
    Hidden,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    Toolbar,
    Button
} from "@material-ui/core";
import {
    InsertChart,
    ChevronLeft,
    ChevronRight,
    Menu,
} from "@material-ui/icons";


const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        height: "100vh",
        overflowY: "hidden"
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth => drawerWidth,
            flexShrink: 0
        }
    },
    appBar: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth => `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth => drawerWidth
        },
        backgroundColor: "#fff",
        boxShadow: "none",
        borderBottom: "1px solid #ccc"
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            display: "none"
        }
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth => drawerWidth,
        backgroundColor: theme.palette.primary.main
    },
    content: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        overflowY: "auto"
    },
    logoContainer: {
        height: "64px",
        width: "59px",
        padding: "15px 10px 15px 10px"
    },
    logo: {
        backgroundColor: "#fff",
        borderRadius: "10px"
    },
    flex1: {
        flex: 1
    }
}));

const PrimaryLayoutRoute = props => {
    const {
        component: Component,
    } = props;

    const history = useHistory();
    const { container } = props;
    const [drawerWidth, setDrawerWidth] = useState(60);
    const classes = useStyles(drawerWidth);
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [locationName, setLocationName] = useState("Company administration");

    const handleDrawerToggle = () => {
        setDrawerWidth(240);
        setMobileOpen(!mobileOpen);
    };

    // useEffect(() => {
    //     const t = window.setTimeout(() => API.setTherapist(therapist), 1000);
    //     return () => window.clearTimeout(t);
    // }, [therapist]);

    const drawer = (
        <>
            <div>
                <div className={classes.toolbar}>
                    <div className={classes.logoContainer}>
                        <img
                            src={logo}
                            className={classes.logo}
                            height="100%"
                            width="100%"
                            alt="Logo"
                        />
                    </div>
                </div>
                <List style={{ overflowX: "hidden" }}>
                    {["Companies"].map(
                        (text, index) => (
                            <ListItem
                                button
                                key={text}
                                onClick={() => {
                                    if (text === 'Companies') {
                                        setLocationName('Company administration');
                                    } else {
                                        setLocationName(text);
                                    }
                                    history.push("/" + text);
                                }}>
                                <ListItemIcon>
                                    {
                                        [
                                            <InsertChart style={{ color: "#fff" }} />,
                                        ][index]
                                    }
                                </ListItemIcon>
                                {drawerWidth !== 60 && <ListItemText style={{ color: "#fff" }} primary={text} />}
                            </ListItem>
                        )
                    )}
                </List>
            </div>
        </>
    );

    return !localStorage.getItem("adminToken") ? (
        <Redirect to={"/admin"} />
    ) : (

        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}>
                        <Menu style={{ color: "black" }} />
                    </IconButton>
                    <Typography variant="h6" noWrap style={{ color: "black", flexGrow: 1 }}>
                        {locationName}
                    </Typography>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={event => {
                            event.preventDefault();
                            localStorage.clear();
                            history.push("/admin");
                        }}>
                        Log Ud
                    </Button>
                </Toolbar>
            </AppBar>
            <nav className={classes.drawer} aria-label="mailbox folders">
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor={theme.direction === "rtl" ? "right" : "left"}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        style={{ backgroundColor: "red !important" }}
                        ModalProps={{
                            keepMounted: true
                        }}>
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        variant="permanent"
                        open>
                        {drawer}
                        {drawerWidth === 60 ? (
                            <IconButton
                                color="inherit"
                                onClick={() => setDrawerWidth(240)}
                                style={{
                                    maxWidth: "60px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    marginTop: "auto"
                                }}>
                                <ChevronRight style={{ color: "#fff" }} />
                            </IconButton>
                        ) : (
                            <IconButton
                                color="inherit"
                                onClick={() => setDrawerWidth(60)}
                                style={{
                                    maxWidth: "60px",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    marginTop: "auto"
                                }}>
                                <ChevronLeft style={{ color: "#fff" }} />
                            </IconButton>
                        )}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <div className={classes.flex1}>
                    <Component />
                </div>
                <Copyright></Copyright>
            </main>
        </div>
    );
}

PrimaryLayoutRoute.propTypes = {
    component: PropTypes.func.isRequired,
    classes: PropTypes.string,
    id: PropTypes.string,
    collapsed: PropTypes.bool,
    hideBreadcrumbs: PropTypes.bool,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    match: PropTypes.objectOf(PropTypes.any).isRequired,
    computedMatch: PropTypes.objectOf(PropTypes.any).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
};

PrimaryLayoutRoute.defaultProps = {
    classes: '',
    id: '',
    collapsed: false,
    hideBreadcrumbs: false,
};

export default withRouter(PrimaryLayoutRoute)
